import axios from 'axios'
import * as R from 'ramda'
import { load_one, load_many } from '@/store/action-helpers.js'

export default {

    async create({ dispatch }, { productId, model }) {
        // Model speichern
        const response = await axios.post(`/api/v1/products/${productId}/variants`, model)

        const [ variantModel ] = await Promise.all([

            // Erstellte Variante laden
            dispatch('loadOne', { id: response.data.id }),

            // Produkt der Variante laden
            dispatch('products/loadOne', { id: response.data.product }, { root: true })

        ])

        return variantModel
    },

    loadAllByOfferModels({ dispatch }, { offerModels })  {
        return R.compose(

            // Promises zusammenfassen
            promises => Promise.all(promises),

            // Varianten laden
            R.map(id => dispatch('loadOne', { id })),

            // Varianten-IDs einlesen
            R.map(R.prop('variant'))

        )(offerModels)
    },

    loadAllByProductId: load_many('products/:productId/variants'),

    loadOne: load_one('variants/:id'),

}
